module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 7.42b9f8db.png";